<template>
  <div>
    <validation-observer ref="permissionsDetailForm">
      <b-overlay
        variant="white"
        :show="submitting"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
      >
        <validation-observer ref="providerRegionDetailForm">
          <b-form ref="PermissionsPermissionsList" class="" @submit.prevent="submit">
            <b-row>
              <b-col md="12" lg="12">
                <validation-provider :name="t('Country')" rules="required" vid="consignor_country">
                  <b-form-group>
                    <div class="d-flex form-group-label">
                      <label for="package_id">{{ t('Package') }}</label>
                      <span class="text-danger">*</span>
                    </div>
                    <validation-provider
                      #default="{ errors }"
                      :name="t('Package')"
                      rules="required"
                    >
                      <b-form-select
                        id="permissions_id"
                        v-model="values.permissions_id"
                        :state="errors.length > 0 ? false : null"
                        :options="
                          [{ text: t('Make a Choice'), value: '' }].concat(permissionsOption)
                        "
                        tabindex="3"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12">
                <b-button
                  variant="primary"
                  class="mt-1 d-flex align-items-center"
                  type="submit"
                  tabindex="11"
                >
                  {{ submitting ? t('Please Wait') : type === 'new' ? t('Add') : t('Edit') }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-overlay>
    </validation-observer>
  </div>
</template>
<script>
import { BCol, BForm, BFormGroup, BRow, BFormSelect, BButton, BOverlay } from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { togglePasswordVisibility } from '@core/mixins/ui/forms';
import { helper } from '@core/mixins/helper';

export default {
  components: {
    BOverlay,
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BForm,
    BFormSelect,

    ValidationObserver,
    ValidationProvider
  },

  mixins: [togglePasswordVisibility, helper],
  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          permissions_id: ''
        };
      }
    }
  },
  data() {
    return {
      statusTypeOptions: [],
      permissionsOption: []
    };
  },
  async created() {
    await this.permissionsOptionsList().then(response => {
      this.permissionsOption = response.map(x => ({
        text: x.description,
        value: x.id
      }));
    });
  },
  mounted() {
    this.statusTypeOptions = [
      { value: 1, text: '0' },
      { value: 0, text: '1' }
    ];
  },

  methods: {
    submit() {
      this.$refs.permissionsDetailForm.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values
          });
        }
      });
    },

    resetForm() {
      this.$refs.PermissionsPermissionsList.reset();
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
